import MainRoutes from "../../Navigation/MainRoutes";

export const MODULE_LABELS = {
  //****DASHBOARD */
  DASHBOARD: "Dashboard",

  //****COMPLAINTS */
  COMPLAINTS: "Complaints",
  HELPDESK: "Helpdesk",
  ALL_COMPLAINTS: "All Complaints",
  DEADLINE_APPROVAL: "Approvals",
  COMPLAINT_REQUESTS: "Complaint Requests",
  COMPLAINT_LEVELS: "Complaint Levels",
  COMPLAINT_CONFIGURATION: "Configuration",
  RATING: "Ratings",

  //**** MIS Dashboard */
  // MIS_QUICK_VIEW: "Quick View",
  // MIS_DETAILED_VIEW: "Detailed View",
  MIS_COMPLAINT_DASHBOARD: "Complaint Dashboard",
  // MIS_LOCATION_ANALYTICS: "Location Analytics",
  MIS_ASSIGNED_COMPLAINTS_REPORT: "Assigned Report",
  MIS_CLOSED_COMPLAINTS_REPORT: "Closed Report",
  MIS_CANCELLED_COMPLAINTS_REPORT: "Cancelled Report",
  MIS_VENDOR_ANALYTICS: "Vendor Analytics",
  MIS_SETTINGS: "Mis Settings",

  //**** COMMUNICATION */
  NOTICE: "Notice",

  //****PEOPLE */
  PEOPLE: "People",
  USERS: "Users",
  USER_REQUESTS: "User Requests",

  //****SOCIETY MANAGEMENT */
  SOCIETY_MANAGEMENT: "Society Management",
  SOCIETY_MANAGE: "Society Manage",
  SOCIETY_REQUESTS: "Society Requests",
  LEVEL: "Level",
  LEVEL_DATA: "Level Data",

  //****SETTINGS */
  SETTINGS: "Settings",
  GROUPING: "Grouping",
  ROLE: "Role",
  TOKEN: "Token",

  //**** MIS Dashboard */

  MIS_QUICK_VIEW: "Quick View",
  MIS_DETAILED_VIEW: "Detailed View",

  //*Help Management */
  HELP_MANAGEMENT: "Help Management",
  ADD_FAQ: "Add FAQ",
  HELP_CENTER: "Help Center",

  //**** CONTACT BOOK */
  CONTACT_BOOK: "Contact Book", 
  DIRECTORY: "Directory",
};

export const sidebarItems = [
  {
    label: MODULE_LABELS?.DASHBOARD,
    path: MainRoutes?.HOME,

    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        className="bi bi-grid"
        viewBox="0 0 16 16"
      >
        <path d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5zM2.5 2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5zm6.5.5A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5zM1 10.5A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5zm6.5.5A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5z" />
      </svg>
    ),
  },
  {
    label: MODULE_LABELS?.COMPLAINTS,
    icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 74 74"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M24.648 28.1547L48.6409 27.5735M24.9386 40.1512L42.9333 39.7153M54.2759 12.4325C56.6621 12.3747 58.9736 13.2672 60.7018 14.9137C62.43 16.5601 63.4334 18.8257 63.4912 21.2119L64.0725 45.2049C64.1303 47.5911 63.2378 49.9026 61.5914 51.6308C59.9449 53.359 57.6794 54.3624 55.2931 54.4202L40.2975 54.7835L25.5199 64.1442L25.3019 55.1468L19.3037 55.2922C16.9174 55.35 14.606 54.4575 12.8778 52.811C11.1495 51.1646 10.1462 48.899 10.0883 46.5128L9.50705 22.5198C9.44924 20.1336 10.3417 17.8221 11.9882 16.0939C13.6346 14.3657 15.9002 13.3623 18.2864 13.3045L54.2759 12.4325Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    children: [
      {
        label: MODULE_LABELS?.HELPDESK,
        path: MainRoutes?.HELPDESK,

        icon: (
          <svg
            width="16"
            height="16"
            viewBox="0 0 27 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 17.7895V13.2105C1 9.97209 2.31696 6.8663 4.66117 4.57638C7.00537 2.28646 10.1848 1 13.5 1C16.8152 1 19.9946 2.28646 22.3388 4.57638C24.683 6.8663 26 9.97209 26 13.2105V17.7895M1 17.7895C1 16.9799 1.32924 16.2034 1.91529 15.6309C2.50134 15.0585 3.2962 14.7368 4.125 14.7368H5.6875C6.5163 14.7368 7.31116 15.0585 7.89721 15.6309C8.48326 16.2034 8.8125 16.9799 8.8125 17.7895V22.3684C8.8125 23.178 8.48326 23.9545 7.89721 24.527C7.31116 25.0994 6.5163 25.4211 5.6875 25.4211H4.125C3.2962 25.4211 2.50134 25.0994 1.91529 24.527C1.32924 23.9545 1 23.178 1 22.3684V17.7895ZM26 17.7895C26 16.9799 25.6708 16.2034 25.0847 15.6309C24.4987 15.0585 23.7038 14.7368 22.875 14.7368H21.3125C20.4837 14.7368 19.6888 15.0585 19.1028 15.6309C18.5167 16.2034 18.1875 16.9799 18.1875 17.7895V22.3684C18.1875 23.178 18.5167 23.9545 19.1028 24.527C19.6888 25.0994 20.4837 25.4211 21.3125 25.4211H22.875M26 17.7895V22.3684C26 23.178 25.6708 23.9545 25.0847 24.527C24.4987 25.0994 23.7038 25.4211 22.875 25.4211M22.875 25.4211C22.875 27.9502 18.6781 30 13.5 30"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        ),
      },
      {
        label: MODULE_LABELS?.ALL_COMPLAINTS,
        path: MainRoutes?.ALLCOMPLAINTS,

        icon: (
          <svg
            width="16"
            height="16"
            viewBox="0 0 29 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.307 30.1765H4.6C3.64522 30.1765 2.72955 29.7922 2.05442 29.1083C1.37928 28.4243 1 27.4967 1 26.5294V4.64706C1 3.6798 1.37928 2.75215 2.05442 2.0682C2.72955 1.38424 3.64522 1 4.6 1H19C19.9548 1 20.8705 1.38424 21.5456 2.0682C22.2207 2.75215 22.6 3.6798 22.6 4.64706V19.2353M17.2 28.3529L20.8 32L28 24.7059M8.2 8.29412H15.4M8.2 15.5882H11.8"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        ),
      },
      {
        label: MODULE_LABELS?.RATING,
        path: MainRoutes?.RATING,

        icon: (
          <svg
            width="16"
            height="16"
            viewBox="0 0 38 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M35.1093 17.1045V2.89465C35.1093 2.39216 34.9097 1.91024 34.5543 1.55493C34.1989 1.19961 33.7169 1 33.2143 1H2.89496C2.39239 1 1.9104 1.19961 1.55502 1.55493C1.19965 1.91024 1 2.39216 1 2.89465V25.6304C1 26.1329 1.19965 26.6148 1.55502 26.9701C1.9104 27.3254 2.39239 27.5251 2.89496 27.5251H14.2647L13.3172 35.1036M1 19.9465H19.9496M10.4748 35.1036H16.1597M29.0422 34.7578L24.9263 36.9139C24.8042 36.9775 24.6668 37.0058 24.5294 36.9958C24.3921 36.9858 24.2603 36.9379 24.1486 36.8573C24.037 36.7767 23.9499 36.6667 23.8972 36.5395C23.8444 36.4124 23.8281 36.273 23.85 36.1371L24.6364 31.5691L21.3069 28.3349C21.2076 28.2389 21.1372 28.1168 21.1039 27.9827C21.0706 27.8486 21.0756 27.7078 21.1185 27.5764C21.1614 27.445 21.2404 27.3284 21.3464 27.2397C21.4524 27.151 21.5812 27.094 21.7181 27.075L26.3191 26.4081L28.377 22.2531C28.4386 22.1294 28.5334 22.0253 28.651 21.9525C28.7685 21.8797 28.9039 21.8411 29.0422 21.8411C29.1804 21.8411 29.3159 21.8797 29.4334 21.9525C29.5509 22.0253 29.6458 22.1294 29.7073 22.2531L31.7652 26.4081L36.3662 27.075C36.5027 27.0946 36.631 27.1521 36.7366 27.2408C36.8421 27.3296 36.9208 27.4461 36.9635 27.5772C37.0063 27.7083 37.0116 27.8487 36.9787 27.9826C36.9458 28.1165 36.8761 28.2386 36.7774 28.3349L33.448 31.5691L34.2325 36.1352C34.256 36.2714 34.2409 36.4114 34.1888 36.5394C34.1368 36.6674 34.0499 36.7783 33.938 36.8594C33.8261 36.9405 33.6937 36.9886 33.5558 36.9982C33.4179 37.0078 33.2801 36.9786 33.158 36.9139L29.0422 34.7578Z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        ),
      },
      {
        label: MODULE_LABELS?.DEADLINE_APPROVAL,
        path: MainRoutes?.DEADLINEAPPROVAL,
        icon: (
          <svg
            width="16"
            height="16"
            viewBox="0 0 29 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 29.3333V24.3333C6 23.8913 5.8244 23.4674 5.51184 23.1548C5.19928 22.8423 4.77536 22.6667 4.33333 22.6667H2.66667C2.22464 22.6667 1.80072 22.8423 1.48816 23.1548C1.17559 23.4674 1 23.8913 1 24.3333V29.3333C1 29.7754 1.17559 30.1993 1.48816 30.5118C1.80072 30.8244 2.22464 31 2.66667 31H4.33333C4.77536 31 5.19928 30.8244 5.51184 30.5118C5.8244 30.1993 6 29.7754 6 29.3333ZM6 29.3333C6 29.7754 6.17559 30.1994 6.48816 30.5119C6.80072 30.8245 7.22464 31.0001 7.66667 31.0001H13.9267C14.2852 31.0001 14.6342 30.8845 14.9219 30.6704C15.2095 30.4563 15.4204 30.1552 15.5233 29.8117L17.5233 24.8117C17.6733 24.3067 17.745 23.7617 17.43 23.3384C17.1167 22.9151 16.5267 22.6667 16 22.6667H12.6667V18.5551C12.6665 18.1617 12.5398 17.7789 12.3053 17.4631C12.0708 17.1473 11.741 16.9153 11.3645 16.8013C10.9881 16.6873 10.5849 16.6975 10.2147 16.8302C9.84441 16.9629 9.52665 17.2112 9.30833 17.5384L6 22.6667V29.3333ZM19.3333 1V7.66667C19.3333 8.10869 19.5089 8.53262 19.8215 8.84518C20.134 9.15774 20.558 9.33333 21 9.33333H27.6667M19.3333 1H7.66667C6.78261 1 5.93477 1.35119 5.30964 1.97631C4.68452 2.60143 4.33333 3.44928 4.33333 4.33333V16.1667M19.3333 1L27.6667 9.33333M27.6667 9.33333V27.6667C27.6667 28.5507 27.3155 29.3986 26.6904 30.0237C26.0652 30.6488 25.2174 31 24.3333 31H20.5"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        ),
      },
      {
        label: MODULE_LABELS?.COMPLAINT_REQUESTS,
        path: MainRoutes?.COMPLAINT_REQUESTS,
        icon: (
          <svg
            width="16"
            height="16"
            viewBox="0 0 29 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 29.3333V24.3333C6 23.8913 5.8244 23.4674 5.51184 23.1548C5.19928 22.8423 4.77536 22.6667 4.33333 22.6667H2.66667C2.22464 22.6667 1.80072 22.8423 1.48816 23.1548C1.17559 23.4674 1 23.8913 1 24.3333V29.3333C1 29.7754 1.17559 30.1993 1.48816 30.5118C1.80072 30.8244 2.22464 31 2.66667 31H4.33333C4.77536 31 5.19928 30.8244 5.51184 30.5118C5.8244 30.1993 6 29.7754 6 29.3333ZM6 29.3333C6 29.7754 6.17559 30.1994 6.48816 30.5119C6.80072 30.8245 7.22464 31.0001 7.66667 31.0001H13.9267C14.2852 31.0001 14.6342 30.8845 14.9219 30.6704C15.2095 30.4563 15.4204 30.1552 15.5233 29.8117L17.5233 24.8117C17.6733 24.3067 17.745 23.7617 17.43 23.3384C17.1167 22.9151 16.5267 22.6667 16 22.6667H12.6667V18.5551C12.6665 18.1617 12.5398 17.7789 12.3053 17.4631C12.0708 17.1473 11.741 16.9153 11.3645 16.8013C10.9881 16.6873 10.5849 16.6975 10.2147 16.8302C9.84441 16.9629 9.52665 17.2112 9.30833 17.5384L6 22.6667V29.3333ZM19.3333 1V7.66667C19.3333 8.10869 19.5089 8.53262 19.8215 8.84518C20.134 9.15774 20.558 9.33333 21 9.33333H27.6667M19.3333 1H7.66667C6.78261 1 5.93477 1.35119 5.30964 1.97631C4.68452 2.60143 4.33333 3.44928 4.33333 4.33333V16.1667M19.3333 1L27.6667 9.33333M27.6667 9.33333V27.6667C27.6667 28.5507 27.3155 29.3986 26.6904 30.0237C26.0652 30.6488 25.2174 31 24.3333 31H20.5"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        ),
      },
      {
        label: MODULE_LABELS?.COMPLAINT_LEVELS,
        path: MainRoutes?.COMPLAINTLEVELS,
        icon: (
          <svg
            width="16"
            height="16"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18.3346 1.66699H28.3346V11.667H18.3346V1.66699Z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M1.66797 18.3337H11.668V28.3337H1.66797V18.3337Z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M18.3346 23.3337C18.3346 24.6597 18.8614 25.9315 19.7991 26.8692C20.7368 27.8069 22.0086 28.3337 23.3346 28.3337C24.6607 28.3337 25.9325 27.8069 26.8702 26.8692C27.8079 25.9315 28.3346 24.6597 28.3346 23.3337C28.3346 22.0076 27.8079 20.7358 26.8702 19.7981C25.9325 18.8604 24.6607 18.3337 23.3346 18.3337C22.0086 18.3337 20.7368 18.8604 19.7991 19.7981C18.8614 20.7358 18.3346 22.0076 18.3346 23.3337Z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M1.66797 6.66699C1.66797 7.3236 1.7973 7.97378 2.04857 8.58041C2.29984 9.18704 2.66814 9.73823 3.13243 10.2025C3.59673 10.6668 4.14792 11.0351 4.75455 11.2864C5.36118 11.5377 6.01136 11.667 6.66797 11.667C7.32458 11.667 7.97476 11.5377 8.58139 11.2864C9.18801 11.0351 9.73921 10.6668 10.2035 10.2025C10.6678 9.73823 11.0361 9.18704 11.2874 8.58041C11.5386 7.97378 11.668 7.3236 11.668 6.66699C11.668 6.01038 11.5386 5.3602 11.2874 4.75357C11.0361 4.14695 10.6678 3.59575 10.2035 3.13146C9.73921 2.66717 9.18801 2.29887 8.58139 2.04759C7.97476 1.79632 7.32458 1.66699 6.66797 1.66699C6.01136 1.66699 5.36118 1.79632 4.75455 2.04759C4.14792 2.29887 3.59673 2.66717 3.13243 3.13146C2.66814 3.59575 2.29984 4.14695 2.04857 4.75357C1.7973 5.3602 1.66797 6.01038 1.66797 6.66699Z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        ),
      },
      {
        label: MODULE_LABELS?.COMPLAINT_CONFIGURATION,
        path: MainRoutes?.COMPLAINTCONFIGURATION,

        icon: (
          <svg
            width="16"
            height="16"
            viewBox="0 0 28 35"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14 24.8333C13.0149 24.8333 12.0702 24.447 11.3736 23.7594C10.677 23.0718 10.2857 22.1391 10.2857 21.1667C10.2857 20.1942 10.677 19.2616 11.3736 18.5739C12.0702 17.8863 13.0149 17.5 14 17.5M14 24.8333C14.9851 24.8333 15.9298 24.447 16.6264 23.7594C17.323 23.0718 17.7143 22.1391 17.7143 21.1667C17.7143 20.1942 17.323 19.2616 16.6264 18.5739C15.9298 17.8863 14.9851 17.5 14 17.5M14 24.8333V27.5833M14 17.5V14.75M19.6262 17.9583L17.2137 19.3333M10.7848 23L8.37054 24.375M19.5711 24.4727L17.1847 23.0555M10.815 19.2788L8.42857 17.8617M17.7143 1V8.33333C17.7143 8.81956 17.9099 9.28588 18.2582 9.6297C18.6065 9.97351 19.0789 10.1667 19.5714 10.1667H27M17.7143 1H4.71429C3.7292 1 2.78445 1.38631 2.08789 2.07394C1.39133 2.76158 1 3.69421 1 4.66667V30.3333C1 31.3058 1.39133 32.2384 2.08789 32.9261C2.78445 33.6137 3.7292 34 4.71429 34H23.2857C24.2708 34 25.2155 33.6137 25.9121 32.9261C26.6087 32.2384 27 31.3058 27 30.3333V10.1667M17.7143 1L27 10.1667"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        ),
      },
    ],
  },
  {
    label: "MIS Dashboard",
    icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 56 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22 22.315C22 21.8797 22.0857 21.4486 22.2523 21.0464C22.4189 20.6442 22.6631 20.2788 22.9709 19.9709C23.2788 19.6631 23.6442 19.4189 24.0464 19.2523C24.4486 19.0857 24.8797 19 25.315 19H30.685C31.1203 19 31.5514 19.0857 31.9536 19.2523C32.3558 19.4189 32.7212 19.6631 33.0291 19.9709C33.3369 20.2788 33.5811 20.6442 33.7477 21.0464C33.9143 21.4486 34 21.8797 34 22.315V51.685C34 52.5642 33.6507 53.4074 33.0291 54.0291C32.4074 54.6507 31.5642 55 30.685 55H25.315C24.4358 55 23.5926 54.6507 22.9709 54.0291C22.3493 53.4074 22 52.5642 22 51.685V22.315Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M43 4.315C43 3.43581 43.3493 2.59262 43.9709 1.97094C44.5926 1.34926 45.4358 1 46.315 1H51.685C52.5642 1 53.4074 1.34926 54.0291 1.97094C54.6507 2.59262 55 3.43581 55 4.315V51.685C55 52.5642 54.6507 53.4074 54.0291 54.0291C53.4074 54.6507 52.5642 55 51.685 55H46.315C45.4358 55 44.5926 54.6507 43.9709 54.0291C43.3493 53.4074 43 52.5642 43 51.685V4.315Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1 49C1 50.5913 1.63214 52.1174 2.75736 53.2426C3.88258 54.3679 5.4087 55 7 55C8.5913 55 10.1174 54.3679 11.2426 53.2426C12.3679 52.1174 13 50.5913 13 49C13 47.4087 12.3679 45.8826 11.2426 44.7574C10.1174 43.6321 8.5913 43 7 43C5.4087 43 3.88258 43.6321 2.75736 44.7574C1.63214 45.8826 1 47.4087 1 49Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    children: [
      // {
      //   label: MODULE_LABELS?.MIS_QUICK_VIEW,
      //   path: MainRoutes?.MISQUICKVIEW,
      //   icon: (
      //     <svg
      //       width="16"
      //       height="16"
      //       viewBox="0 0 38 34"
      //       fill="none"
      //       xmlns="http://www.w3.org/2000/svg"
      //     >
      //       <path
      //         d="M9 33H29M13 25V33M25 25V33M11 17L17 11L21 15L27 9M1 3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H35C35.5304 1 36.0391 1.21071 36.4142 1.58579C36.7893 1.96086 37 2.46957 37 3V23C37 23.5304 36.7893 24.0391 36.4142 24.4142C36.0391 24.7893 35.5304 25 35 25H3C2.46957 25 1.96086 24.7893 1.58579 24.4142C1.21071 24.0391 1 23.5304 1 23V3Z"
      //         stroke="currentColor"
      //         stroke-width="2"
      //         stroke-linecap="round"
      //         stroke-linejoin="round"
      //       />
      //     </svg>
      //   ),
      // },
      // {
      //   label: MODULE_LABELS?.MIS_DETAILED_VIEW,
      //   path: MainRoutes?.MISDETAILEDVIEW,
      //   icon: (
      //     <svg
      //       width="16"
      //       height="16"
      //       viewBox="0 0 38 34"
      //       fill="none"
      //       xmlns="http://www.w3.org/2000/svg"
      //     >
      //       <path
      //         d="M9 33H29M13 25V33M25 25V33M13 17V9M19 17V15M25 17V13M1 3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H35C35.5304 1 36.0391 1.21071 36.4142 1.58579C36.7893 1.96086 37 2.46957 37 3V23C37 23.5304 36.7893 24.0391 36.4142 24.4142C36.0391 24.7893 35.5304 25 35 25H3C2.46957 25 1.96086 24.7893 1.58579 24.4142C1.21071 24.0391 1 23.5304 1 23V3Z"
      //         stroke="currentColor"
      //         stroke-width="2"
      //         stroke-linecap="round"
      //         stroke-linejoin="round"
      //       />
      //     </svg>
      //   ),
      // },
      {
        label: MODULE_LABELS?.MIS_COMPLAINT_DASHBOARD,
        path: MainRoutes?.MIS_COMPLAINT_DASHBOARD,
        icon: (
          <svg
            width="16"
            height="16"
           viewBox="0 0 45 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 6V42H42M40 36V42M32 32V42M24 26V42M16 32V42M6 22C18 22 16 12 24 12C32 12 30 22 42 22"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        ),
      },
      // {
      //   label: MODULE_LABELS?.MIS_LOCATION_ANALYTICS,
      //   path: MainRoutes?.MIS_LOCATION_ANALYTICS,
      //   icon: (
      //     <svg
      //       width="16"
      //       height="16"
      //       viewBox="0 0 38 34"
      //       fill="none"
      //       xmlns="http://www.w3.org/2000/svg"
      //     >
      //       <path
      //         d="M9 33H29M13 25V33M25 25V33M11 17L17 11L21 15L27 9M1 3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H35C35.5304 1 36.0391 1.21071 36.4142 1.58579C36.7893 1.96086 37 2.46957 37 3V23C37 23.5304 36.7893 24.0391 36.4142 24.4142C36.0391 24.7893 35.5304 25 35 25H3C2.46957 25 1.96086 24.7893 1.58579 24.4142C1.21071 24.0391 1 23.5304 1 23V3Z"
      //         stroke="currentColor"
      //         stroke-width="2"
      //         stroke-linecap="round"
      //         stroke-linejoin="round"
      //       />
      //     </svg>
      //   ),
      // },
      {
        label: MODULE_LABELS?.MIS_ASSIGNED_COMPLAINTS_REPORT,
        path: MainRoutes?.MIS_ASSIGNED_COMPLAINTS_REPORT,
        icon: (
          <svg
            width="16"
            height="20"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 10H14C12.9391 10 11.9217 10.4214 11.1716 11.1716C10.4214 11.9217 10 12.9391 10 14V38C10 39.0609 10.4214 40.0783 11.1716 40.8284C11.9217 41.5786 12.9391 42 14 42H34C35.0609 42 36.0783 41.5786 36.8284 40.8284C37.5786 40.0783 38 39.0609 38 38V14C38 12.9391 37.5786 11.9217 36.8284 11.1716C36.0783 10.4214 35.0609 10 34 10H30M18 10C18 8.93913 18.4214 7.92172 19.1716 7.17157C19.9217 6.42143 20.9391 6 22 6H26C27.0609 6 28.0783 6.42143 28.8284 7.17157C29.5786 7.92172 30 8.93913 30 10M18 10C18 11.0609 18.4214 12.0783 19.1716 12.8284C19.9217 13.5786 20.9391 14 22 14H26C27.0609 14 28.0783 13.5786 28.8284 12.8284C29.5786 12.0783 30 11.0609 30 10M18 24H30M18 32H30"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        ),
      },
      {
        label: MODULE_LABELS?.MIS_CLOSED_COMPLAINTS_REPORT,
        path: MainRoutes?.MIS_CLOSED_COMPLAINTS_REPORT,
        icon: (
          <svg
            width="16"
            height="16"
     viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8 16H40M16 8V16M20 32L28 24M28 32L20 24M8 10C8 9.46957 8.21071 8.96086 8.58579 8.58579C8.96086 8.21071 9.46957 8 10 8H38C38.5304 8 39.0391 8.21071 39.4142 8.58579C39.7893 8.96086 40 9.46957 40 10V38C40 38.5304 39.7893 39.0391 39.4142 39.4142C39.0391 39.7893 38.5304 40 38 40H10C9.46957 40 8.96086 39.7893 8.58579 39.4142C8.21071 39.0391 8 38.5304 8 38V10Z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        ),
      },
      {
        label: MODULE_LABELS?.MIS_CANCELLED_COMPLAINTS_REPORT,
        path: MainRoutes?.MIS_CANCELLED_COMPLAINTS_REPORT,
        icon: (
          <svg
          width="16"
          height="16"
               viewBox="0 0 45 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M25 32H8C7.46957 32 6.96086 31.7893 6.58579 31.4142C6.21071 31.0391 6 30.5304 6 30V10C6 9.46957 6.21071 8.96086 6.58579 8.58579C6.96086 8.21071 7.46957 8 8 8H40C40.5304 8 41.0391 8.21071 41.4142 8.58579C41.7893 8.96086 42 9.46957 42 10V25M14 40H24M18 32V40M34 42L42 34M32 38C32 39.5913 32.6321 41.1174 33.7574 42.2426C34.8826 43.3679 36.4087 44 38 44C39.5913 44 41.1174 43.3679 42.2426 42.2426C43.3679 41.1174 44 39.5913 44 38C44 36.4087 43.3679 34.8826 42.2426 33.7574C41.1174 32.6321 39.5913 32 38 32C36.4087 32 34.8826 32.6321 33.7574 33.7574C32.6321 34.8826 32 36.4087 32 38Z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        ),
      },
      {
        label: MODULE_LABELS?.MIS_VENDOR_ANALYTICS,
        path: MainRoutes?.MIS_VENDOR_ANALYTICS,
        icon: (
          <svg
          width="16"
          height="16"
          viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8 24L14 16L22 20L32 8L40 16M8 38L16 26L24 30L32 20L40 28V38H8Z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        ),
      },
      {
        label: MODULE_LABELS?.MIS_SETTINGS,
        path: MainRoutes?.MIS_SETTINGS,
        icon: (
          <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        className="bi bi-gear"
        viewBox="0 0 16 16"
      >
        <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492M5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0" />
        <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115z" />
      </svg>
        ),
      },
    ],
  },
  {
    label: "Communication",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        className="bi bi-megaphone"
        viewBox="0 0 16 16"
      >
        <path d="M13 2.5a1.5 1.5 0 0 1 3 0v11a1.5 1.5 0 0 1-3 0v-.214c-2.162-1.241-4.49-1.843-6.912-2.083l.405 2.712A1 1 0 0 1 5.51 15.1h-.548a1 1 0 0 1-.916-.599l-1.85-3.49-.202-.003A2.014 2.014 0 0 1 0 9V7a2.02 2.02 0 0 1 1.992-2.013 75 75 0 0 0 2.483-.075c3.043-.154 6.148-.849 8.525-2.199zm1 0v11a.5.5 0 0 0 1 0v-11a.5.5 0 0 0-1 0m-1 1.35c-2.344 1.205-5.209 1.842-8 2.033v4.233q.27.015.537.036c2.568.189 5.093.744 7.463 1.993zm-9 6.215v-4.13a95 95 0 0 1-1.992.052A1.02 1.02 0 0 0 1 7v2c0 .55.448 1.002 1.006 1.009A61 61 0 0 1 4 10.065m-.657.975 1.609 3.037.01.024h.548l-.002-.014-.443-2.966a68 68 0 0 0-1.722-.082z" />
      </svg>
    ),
    children: [
      {
        label: MODULE_LABELS?.NOTICE,
        path: MainRoutes?.NOTICE,
        icon: (
          <svg
            width="16"
            height="16"
            viewBox="0 0 20 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.0013 1.66699V11.667L1.66797 18.3337V21.667H18.3346V18.3337L15.0013 11.667V1.66699M10.0013 21.667V30.0003M3.33464 1.66699H16.668"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        ),
      },
      // {
      //   label: "Discussion",
      //   path: MainRoutes?.DISCUSSION,
      //   icon: exampleSVG,
      // },
      // {
      //   label: "Meeting",
      //   path: MainRoutes?.MEETING,
      //   icon: exampleSVG,
      // },
      // {
      //   label: "Poll",
      //   path: MainRoutes?.POLL,
      //   icon: exampleSVG,
      // },
    ],
  },
  {
    label: MODULE_LABELS?.PEOPLE,

    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        className="bi bi-people"
        viewBox="0 0 16 16"
      >
        <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1zm-7.978-1L7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002-.014.002zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0M6.936 9.28a6 6 0 0 0-1.23-.247A7 7 0 0 0 5 9c-4 0-5 3-5 4q0 1 1 1h4.216A2.24 2.24 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816M4.92 10A5.5 5.5 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275ZM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4" />
      </svg>
    ),
    children: [
      {
        label: MODULE_LABELS?.USERS,
        path: MainRoutes?.USERS,

        icon: (
          <svg
            width="16"
            height="16"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M37.0313 23.0373C36.8887 23.1218 36.7184 23.1462 36.5578 23.1052C36.3973 23.0642 36.2596 22.9611 36.175 22.8185C34.8734 20.631 32.9047 19.381 30.775 19.381C30.7113 19.3802 30.648 19.3697 30.5875 19.3498C30.3903 19.3704 30.1921 19.3808 29.9938 19.381C29.828 19.381 29.669 19.3152 29.5518 19.198C29.4346 19.0808 29.3688 18.9218 29.3688 18.756C29.3688 18.5903 29.4346 18.4313 29.5518 18.3141C29.669 18.1969 29.828 18.131 29.9938 18.131C30.812 18.1308 31.6137 17.9011 32.3079 17.468C33.0021 17.0349 33.561 16.4159 33.921 15.6811C34.2811 14.9464 34.4278 14.1254 34.3447 13.3114C34.2615 12.4975 33.9518 11.7231 33.4506 11.0764C32.9495 10.4296 32.277 9.93631 31.5096 9.65255C30.7421 9.3688 29.9105 9.30594 29.1091 9.47112C28.3078 9.63629 27.5688 10.0229 26.9761 10.587C26.3834 11.1511 25.9608 11.8701 25.7563 12.6623C25.7148 12.8229 25.6113 12.9604 25.4684 13.0447C25.3256 13.1289 25.1551 13.153 24.9945 13.1115C24.834 13.0701 24.6964 12.9665 24.6122 12.8237C24.5279 12.6808 24.5039 12.5104 24.5453 12.3498C24.7747 11.4604 25.2183 10.6407 25.8375 9.96236C26.4567 9.28399 27.2326 8.76756 28.0974 8.45818C28.9622 8.14881 29.8896 8.05591 30.7986 8.18761C31.7076 8.3193 32.5705 8.67157 33.312 9.21365C34.0534 9.75573 34.6508 10.4711 35.052 11.2973C35.4533 12.1235 35.6461 13.0354 35.6136 13.9533C35.5811 14.8712 35.3244 15.7672 34.8658 16.563C34.4072 17.3588 33.7607 18.0302 32.9828 18.5185C34.6719 19.1201 36.1875 20.3935 37.25 22.1873C37.3325 22.3293 37.3559 22.4981 37.3149 22.6572C37.274 22.8162 37.1721 22.9528 37.0313 23.0373ZM29.2906 33.4373C29.3734 33.5807 29.3958 33.7511 29.353 33.911C29.3103 34.071 29.2058 34.2074 29.0625 34.2904C28.9678 34.346 28.8598 34.3751 28.75 34.3748C28.6404 34.3747 28.5328 34.3457 28.4379 34.2909C28.343 34.236 28.2642 34.1572 28.2094 34.0623C27.367 32.6343 26.1667 31.4507 24.727 30.6284C23.2873 29.8061 21.658 29.3737 20 29.3737C18.342 29.3737 16.7127 29.8061 15.273 30.6284C13.8333 31.4507 12.633 32.6343 11.7906 34.0623C11.7041 34.1983 11.5684 34.2957 11.4119 34.334C11.2553 34.3724 11.09 34.3488 10.9504 34.2681C10.8108 34.1874 10.7078 34.056 10.6629 33.9011C10.618 33.7463 10.6347 33.5801 10.7094 33.4373C12.066 31.1077 14.2535 29.3774 16.8328 28.5935C15.4661 27.8842 14.3771 26.7365 13.7404 25.3345C13.1036 23.9325 12.9559 22.3574 13.321 20.8615C13.6861 19.3655 14.5429 18.0355 15.7539 17.0845C16.9649 16.1335 18.4602 15.6165 20 15.6165C21.5398 15.6165 23.0351 16.1335 24.2461 17.0845C25.4571 18.0355 26.3139 19.3655 26.679 20.8615C27.0441 22.3574 26.8964 23.9325 26.2596 25.3345C25.6229 26.7365 24.5339 27.8842 23.1672 28.5935C25.7465 29.3774 27.934 31.1077 29.2906 33.4373ZM20 28.1248C21.1125 28.1248 22.2001 27.7949 23.1251 27.1768C24.0501 26.5587 24.7711 25.6802 25.1968 24.6524C25.6226 23.6246 25.734 22.4936 25.5169 21.4024C25.2999 20.3113 24.7641 19.309 23.9775 18.5223C23.1908 17.7356 22.1885 17.1999 21.0974 16.9829C20.0062 16.7658 18.8752 16.8772 17.8474 17.303C16.8196 17.7287 15.9411 18.4497 15.323 19.3747C14.7049 20.2997 14.375 21.3873 14.375 22.4998C14.375 23.9916 14.9676 25.4224 16.0225 26.4773C17.0774 27.5322 18.5082 28.1248 20 28.1248ZM10 18.1248C9.18179 18.1245 8.38005 17.8948 7.68584 17.4618C6.99163 17.0287 6.43277 16.4096 6.07274 15.6749C5.7127 14.9402 5.56593 14.1192 5.64908 13.3052C5.73222 12.4912 6.04197 11.7169 6.54312 11.0701C7.04428 10.4233 7.71676 9.93006 8.4842 9.6463C9.25163 9.36255 10.0833 9.29969 10.8846 9.46487C11.686 9.63004 12.425 10.0166 13.0177 10.5807C13.6103 11.1448 14.0329 11.8638 14.2375 12.656C14.2789 12.8166 14.3825 12.9542 14.5253 13.0384C14.6682 13.1227 14.8386 13.1467 14.9992 13.1053C15.1598 13.0638 15.2973 12.9603 15.3816 12.8174C15.4658 12.6746 15.4899 12.5041 15.4484 12.3435C15.2181 11.451 14.772 10.6288 14.1493 9.94911C13.5266 9.26947 12.7464 8.75327 11.8774 8.44592C11.0084 8.13857 10.0772 8.0495 9.16563 8.18653C8.2541 8.32356 7.39022 8.68251 6.64997 9.23178C5.90973 9.78105 5.31582 10.5038 4.92048 11.3365C4.52514 12.1692 4.34049 13.0863 4.38278 14.0071C4.42507 14.9279 4.693 15.8242 5.163 16.6171C5.63299 17.4101 6.29066 18.0754 7.07813 18.5545C5.04736 19.1713 3.26765 20.4226 2 22.1248C1.90055 22.2574 1.85784 22.4241 1.88128 22.5882C1.90473 22.7523 1.99239 22.9003 2.125 22.9998C2.25761 23.0993 2.4243 23.142 2.58839 23.1185C2.75249 23.0951 2.90055 23.0074 3 22.8748C3.81121 21.784 4.86728 20.899 6.08314 20.2911C7.29899 19.6831 8.64064 19.3693 10 19.3748C10.1658 19.3748 10.3247 19.3089 10.4419 19.1917C10.5592 19.0745 10.625 18.9156 10.625 18.7498C10.625 18.584 10.5592 18.4251 10.4419 18.3079C10.3247 18.1906 10.1658 18.1248 10 18.1248Z"
              fill="currentColor"
            />
          </svg>
        ),
      },
      {
        label: MODULE_LABELS?.USER_REQUESTS,
        path: MainRoutes?.USERREQUEST,
        isHidden: true,
        icon: (
          <svg
            width="16"
            height="16"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M37.0313 23.0373C36.8887 23.1218 36.7184 23.1462 36.5578 23.1052C36.3973 23.0642 36.2596 22.9611 36.175 22.8185C34.8734 20.631 32.9047 19.381 30.775 19.381C30.7113 19.3802 30.648 19.3697 30.5875 19.3498C30.3903 19.3704 30.1921 19.3808 29.9938 19.381C29.828 19.381 29.669 19.3152 29.5518 19.198C29.4346 19.0808 29.3688 18.9218 29.3688 18.756C29.3688 18.5903 29.4346 18.4313 29.5518 18.3141C29.669 18.1969 29.828 18.131 29.9938 18.131C30.812 18.1308 31.6137 17.9011 32.3079 17.468C33.0021 17.0349 33.561 16.4159 33.921 15.6811C34.2811 14.9464 34.4278 14.1254 34.3447 13.3114C34.2615 12.4975 33.9518 11.7231 33.4506 11.0764C32.9495 10.4296 32.277 9.93631 31.5096 9.65255C30.7421 9.3688 29.9105 9.30594 29.1091 9.47112C28.3078 9.63629 27.5688 10.0229 26.9761 10.587C26.3834 11.1511 25.9608 11.8701 25.7563 12.6623C25.7148 12.8229 25.6113 12.9604 25.4684 13.0447C25.3256 13.1289 25.1551 13.153 24.9945 13.1115C24.834 13.0701 24.6964 12.9665 24.6122 12.8237C24.5279 12.6808 24.5039 12.5104 24.5453 12.3498C24.7747 11.4604 25.2183 10.6407 25.8375 9.96236C26.4567 9.28399 27.2326 8.76756 28.0974 8.45818C28.9622 8.14881 29.8896 8.05591 30.7986 8.18761C31.7076 8.3193 32.5705 8.67157 33.312 9.21365C34.0534 9.75573 34.6508 10.4711 35.052 11.2973C35.4533 12.1235 35.6461 13.0354 35.6136 13.9533C35.5811 14.8712 35.3244 15.7672 34.8658 16.563C34.4072 17.3588 33.7607 18.0302 32.9828 18.5185C34.6719 19.1201 36.1875 20.3935 37.25 22.1873C37.3325 22.3293 37.3559 22.4981 37.3149 22.6572C37.274 22.8162 37.1721 22.9528 37.0313 23.0373ZM29.2906 33.4373C29.3734 33.5807 29.3958 33.7511 29.353 33.911C29.3103 34.071 29.2058 34.2074 29.0625 34.2904C28.9678 34.346 28.8598 34.3751 28.75 34.3748C28.6404 34.3747 28.5328 34.3457 28.4379 34.2909C28.343 34.236 28.2642 34.1572 28.2094 34.0623C27.367 32.6343 26.1667 31.4507 24.727 30.6284C23.2873 29.8061 21.658 29.3737 20 29.3737C18.342 29.3737 16.7127 29.8061 15.273 30.6284C13.8333 31.4507 12.633 32.6343 11.7906 34.0623C11.7041 34.1983 11.5684 34.2957 11.4119 34.334C11.2553 34.3724 11.09 34.3488 10.9504 34.2681C10.8108 34.1874 10.7078 34.056 10.6629 33.9011C10.618 33.7463 10.6347 33.5801 10.7094 33.4373C12.066 31.1077 14.2535 29.3774 16.8328 28.5935C15.4661 27.8842 14.3771 26.7365 13.7404 25.3345C13.1036 23.9325 12.9559 22.3574 13.321 20.8615C13.6861 19.3655 14.5429 18.0355 15.7539 17.0845C16.9649 16.1335 18.4602 15.6165 20 15.6165C21.5398 15.6165 23.0351 16.1335 24.2461 17.0845C25.4571 18.0355 26.3139 19.3655 26.679 20.8615C27.0441 22.3574 26.8964 23.9325 26.2596 25.3345C25.6229 26.7365 24.5339 27.8842 23.1672 28.5935C25.7465 29.3774 27.934 31.1077 29.2906 33.4373ZM20 28.1248C21.1125 28.1248 22.2001 27.7949 23.1251 27.1768C24.0501 26.5587 24.7711 25.6802 25.1968 24.6524C25.6226 23.6246 25.734 22.4936 25.5169 21.4024C25.2999 20.3113 24.7641 19.309 23.9775 18.5223C23.1908 17.7356 22.1885 17.1999 21.0974 16.9829C20.0062 16.7658 18.8752 16.8772 17.8474 17.303C16.8196 17.7287 15.9411 18.4497 15.323 19.3747C14.7049 20.2997 14.375 21.3873 14.375 22.4998C14.375 23.9916 14.9676 25.4224 16.0225 26.4773C17.0774 27.5322 18.5082 28.1248 20 28.1248ZM10 18.1248C9.18179 18.1245 8.38005 17.8948 7.68584 17.4618C6.99163 17.0287 6.43277 16.4096 6.07274 15.6749C5.7127 14.9402 5.56593 14.1192 5.64908 13.3052C5.73222 12.4912 6.04197 11.7169 6.54312 11.0701C7.04428 10.4233 7.71676 9.93006 8.4842 9.6463C9.25163 9.36255 10.0833 9.29969 10.8846 9.46487C11.686 9.63004 12.425 10.0166 13.0177 10.5807C13.6103 11.1448 14.0329 11.8638 14.2375 12.656C14.2789 12.8166 14.3825 12.9542 14.5253 13.0384C14.6682 13.1227 14.8386 13.1467 14.9992 13.1053C15.1598 13.0638 15.2973 12.9603 15.3816 12.8174C15.4658 12.6746 15.4899 12.5041 15.4484 12.3435C15.2181 11.451 14.772 10.6288 14.1493 9.94911C13.5266 9.26947 12.7464 8.75327 11.8774 8.44592C11.0084 8.13857 10.0772 8.0495 9.16563 8.18653C8.2541 8.32356 7.39022 8.68251 6.64997 9.23178C5.90973 9.78105 5.31582 10.5038 4.92048 11.3365C4.52514 12.1692 4.34049 13.0863 4.38278 14.0071C4.42507 14.9279 4.693 15.8242 5.163 16.6171C5.63299 17.4101 6.29066 18.0754 7.07813 18.5545C5.04736 19.1713 3.26765 20.4226 2 22.1248C1.90055 22.2574 1.85784 22.4241 1.88128 22.5882C1.90473 22.7523 1.99239 22.9003 2.125 22.9998C2.25761 23.0993 2.4243 23.142 2.58839 23.1185C2.75249 23.0951 2.90055 23.0074 3 22.8748C3.81121 21.784 4.86728 20.899 6.08314 20.2911C7.29899 19.6831 8.64064 19.3693 10 19.3748C10.1658 19.3748 10.3247 19.3089 10.4419 19.1917C10.5592 19.0745 10.625 18.9156 10.625 18.7498C10.625 18.584 10.5592 18.4251 10.4419 18.3079C10.3247 18.1906 10.1658 18.1248 10 18.1248Z"
              fill="currentColor"
            />
          </svg>
        ),
      },
    ],
  },

  {
    label: MODULE_LABELS?.SOCIETY_MANAGEMENT,

    icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 50 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 13H25M1 1H13M7 1V34C7 34.7956 7.31607 35.5587 7.87868 36.1213C8.44129 36.6839 9.20435 37 10 37H25M25 10C25 9.20435 25.3161 8.44129 25.8787 7.87868C26.4413 7.31607 27.2044 7 28 7H46C46.7956 7 47.5587 7.31607 48.1213 7.87868C48.6839 8.44129 49 9.20435 49 10V16C49 16.7956 48.6839 17.5587 48.1213 18.1213C47.5587 18.6839 46.7956 19 46 19H28C27.2044 19 26.4413 18.6839 25.8787 18.1213C25.3161 17.5587 25 16.7956 25 16V10ZM25 34C25 33.2044 25.3161 32.4413 25.8787 31.8787C26.4413 31.3161 27.2044 31 28 31H46C46.7956 31 47.5587 31.3161 48.1213 31.8787C48.6839 32.4413 49 33.2044 49 34V40C49 40.7956 48.6839 41.5587 48.1213 42.1213C47.5587 42.6839 46.7956 43 46 43H28C27.2044 43 26.4413 42.6839 25.8787 42.1213C25.3161 41.5587 25 40.7956 25 40V34Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    children: [
      {
        label: MODULE_LABELS?.SOCIETY_MANAGE,
        path: MainRoutes?.SOCIETYMANAGE,

        icon: (
          <svg
            width="30"
            height="28"
            viewBox="0 0 30 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.0013 6.66699C10.0013 7.99307 10.5281 9.26484 11.4658 10.2025C12.4034 11.1402 13.6752 11.667 15.0013 11.667C16.3274 11.667 17.5992 11.1402 18.5368 10.2025C19.4745 9.26484 20.0013 7.99307 20.0013 6.66699C20.0013 5.34091 19.4745 4.06914 18.5368 3.13146C17.5992 2.19378 16.3274 1.66699 15.0013 1.66699C13.6752 1.66699 12.4034 2.19378 11.4658 3.13146C10.5281 4.06914 10.0013 5.34091 10.0013 6.66699Z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M18.3346 21.667C18.3346 22.9931 18.8614 24.2648 19.7991 25.2025C20.7368 26.1402 22.0086 26.667 23.3346 26.667C24.6607 26.667 25.9325 26.1402 26.8702 25.2025C27.8079 24.2648 28.3346 22.9931 28.3346 21.667C28.3346 20.3409 27.8079 19.0691 26.8702 18.1315C25.9325 17.1938 24.6607 16.667 23.3346 16.667C22.0086 16.667 20.7368 17.1938 19.7991 18.1315C18.8614 19.0691 18.3346 20.3409 18.3346 21.667Z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M1.66797 21.667C1.66797 22.3236 1.7973 22.9738 2.04857 23.5804C2.29984 24.187 2.66814 24.7382 3.13243 25.2025C3.59673 25.6668 4.14792 26.0351 4.75455 26.2864C5.36118 26.5377 6.01136 26.667 6.66797 26.667C7.32458 26.667 7.97476 26.5377 8.58139 26.2864C9.18801 26.0351 9.73921 25.6668 10.2035 25.2025C10.6678 24.7382 11.0361 24.187 11.2874 23.5804C11.5386 22.9738 11.668 22.3236 11.668 21.667C11.668 21.0104 11.5386 20.3602 11.2874 19.7536C11.0361 19.1469 10.6678 18.5958 10.2035 18.1315C9.73921 17.6672 9.18801 17.2989 8.58139 17.0476C7.97476 16.7963 7.32458 16.667 6.66797 16.667C6.01136 16.667 5.36118 16.7963 4.75455 17.0476C4.14792 17.2989 3.59673 17.6672 3.13243 18.1315C2.66814 18.5958 2.29984 19.1469 2.04857 19.7536C1.7973 20.3602 1.66797 21.0104 1.66797 21.667Z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        ),
      },
      {
        label: MODULE_LABELS?.SOCIETY_REQUESTS,
        path: MainRoutes?.SOCIETYREQUESTS,
        isHidden: true,
        icon: (
          <svg
            width="30"
            height="28"
            viewBox="0 0 30 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.0013 6.66699C10.0013 7.99307 10.5281 9.26484 11.4658 10.2025C12.4034 11.1402 13.6752 11.667 15.0013 11.667C16.3274 11.667 17.5992 11.1402 18.5368 10.2025C19.4745 9.26484 20.0013 7.99307 20.0013 6.66699C20.0013 5.34091 19.4745 4.06914 18.5368 3.13146C17.5992 2.19378 16.3274 1.66699 15.0013 1.66699C13.6752 1.66699 12.4034 2.19378 11.4658 3.13146C10.5281 4.06914 10.0013 5.34091 10.0013 6.66699Z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M18.3346 21.667C18.3346 22.9931 18.8614 24.2648 19.7991 25.2025C20.7368 26.1402 22.0086 26.667 23.3346 26.667C24.6607 26.667 25.9325 26.1402 26.8702 25.2025C27.8079 24.2648 28.3346 22.9931 28.3346 21.667C28.3346 20.3409 27.8079 19.0691 26.8702 18.1315C25.9325 17.1938 24.6607 16.667 23.3346 16.667C22.0086 16.667 20.7368 17.1938 19.7991 18.1315C18.8614 19.0691 18.3346 20.3409 18.3346 21.667Z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M1.66797 21.667C1.66797 22.3236 1.7973 22.9738 2.04857 23.5804C2.29984 24.187 2.66814 24.7382 3.13243 25.2025C3.59673 25.6668 4.14792 26.0351 4.75455 26.2864C5.36118 26.5377 6.01136 26.667 6.66797 26.667C7.32458 26.667 7.97476 26.5377 8.58139 26.2864C9.18801 26.0351 9.73921 25.6668 10.2035 25.2025C10.6678 24.7382 11.0361 24.187 11.2874 23.5804C11.5386 22.9738 11.668 22.3236 11.668 21.667C11.668 21.0104 11.5386 20.3602 11.2874 19.7536C11.0361 19.1469 10.6678 18.5958 10.2035 18.1315C9.73921 17.6672 9.18801 17.2989 8.58139 17.0476C7.97476 16.7963 7.32458 16.667 6.66797 16.667C6.01136 16.667 5.36118 16.7963 4.75455 17.0476C4.14792 17.2989 3.59673 17.6672 3.13243 18.1315C2.66814 18.5958 2.29984 19.1469 2.04857 19.7536C1.7973 20.3602 1.66797 21.0104 1.66797 21.667Z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        ),
      },
      {
        label: MODULE_LABELS?.LEVEL,
        path: MainRoutes?.LEVELS,

        icon: (
          <svg
            width="30"
            height="28"
            viewBox="0 0 30 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.0013 11.667L1.66797 13.3337L15.0013 20.0003L28.3346 13.3337L25.0013 11.667M1.66797 20.0003L15.0013 26.667L28.3346 20.0003M15.0013 1.66699V13.3337M15.0013 13.3337L20.0013 8.33366M15.0013 13.3337L10.0013 8.33366"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        ),
      },
      {
        label: MODULE_LABELS?.LEVEL_DATA,
        path: MainRoutes?.LEVELDATA,

        icon: (
          <svg
            width="20"
            height="20"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.332 20.8333V27.0833C13.332 28.6933 16.3154 30 19.9987 30C23.682 30 26.6654 28.6933 26.6654 27.0833V20.8333M23.332 5V11.6667C23.332 12.1087 23.5076 12.5326 23.8202 12.8452C24.1327 13.1577 24.5567 13.3333 24.9987 13.3333H31.6654M23.332 5H11.6654C10.7813 5 9.93346 5.35119 9.30834 5.97631C8.68322 6.60143 8.33203 7.44928 8.33203 8.33333V31.6667C8.33203 32.5507 8.68322 33.3986 9.30834 34.0237C9.93346 34.6488 10.7813 35 11.6654 35H28.332C29.2161 35 30.0639 34.6488 30.6891 34.0237C31.3142 33.3986 31.6654 32.5507 31.6654 31.6667V13.3333M23.332 5L31.6654 13.3333M13.332 21.25C13.332 22.0235 14.0344 22.7654 15.2847 23.3124C16.5349 23.8594 18.2306 24.1667 19.9987 24.1667C21.7668 24.1667 23.4625 23.8594 24.7127 23.3124C25.963 22.7654 26.6654 22.0235 26.6654 21.25C26.6654 20.4765 25.963 19.7346 24.7127 19.1876C23.4625 18.6406 21.7668 18.3333 19.9987 18.3333C18.2306 18.3333 16.5349 18.6406 15.2847 19.1876C14.0344 19.7346 13.332 20.4765 13.332 21.25Z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        ),
      },
    ],
  },
  {
    label: MODULE_LABELS?.SETTINGS,

    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        className="bi bi-gear"
        viewBox="0 0 16 16"
      >
        <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492M5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0" />
        <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115z" />
      </svg>
    ),
    children: [
      {
        label: MODULE_LABELS?.GROUPING,
        path: MainRoutes?.GROUPING,

        icon: (
          <svg
            width="20"
            height="20"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_8127_11313)">
              <path
                d="M37.2543 20.8441L29.5543 17.2996V7.14409C29.5507 6.93103 29.486 6.72348 29.3678 6.54618C29.2496 6.36887 29.0829 6.2293 28.8876 6.14409L20.5543 2.31076C20.408 2.24307 20.2488 2.20801 20.0876 2.20801C19.9264 2.20801 19.7672 2.24307 19.6209 2.31076L11.2876 6.14409C11.0947 6.23335 10.9315 6.37605 10.8173 6.55526C10.7031 6.73447 10.6426 6.94268 10.6431 7.1552V17.3108L2.97648 20.8441C2.78361 20.9334 2.62039 21.076 2.50616 21.2553C2.39194 21.4345 2.33151 21.6427 2.33203 21.8552V32.7219C2.33151 32.9344 2.39194 33.1426 2.50616 33.3218C2.62039 33.501 2.78361 33.6437 2.97648 33.733L11.3098 37.5663C11.4561 37.634 11.6153 37.6691 11.7765 37.6691C11.9376 37.6691 12.0969 37.634 12.2431 37.5663L20.1098 33.9441L27.9765 37.5663C28.1227 37.634 28.282 37.6691 28.4431 37.6691C28.6043 37.6691 28.7635 37.634 28.9098 37.5663L37.2431 33.733C37.436 33.6437 37.5992 33.501 37.7135 33.3218C37.8277 33.1426 37.8881 32.9344 37.8876 32.7219V21.8552C37.8891 21.6439 37.8303 21.4365 37.7181 21.2574C37.606 21.0783 37.445 20.935 37.2543 20.8441ZM34.132 21.8552L28.4543 24.4441L22.7765 21.8552L28.4543 19.2441L34.132 21.8552ZM20.1098 4.53298L25.7876 7.14409L20.1098 9.7552L14.4431 7.14409L20.1098 4.53298ZM11.7765 19.233L17.4543 21.8441L11.7765 24.4441L6.0987 21.8552L11.7765 19.233ZM18.9987 31.9996L11.7765 35.333L4.55426 31.9996V23.5885L11.3098 26.6663C11.4531 26.7307 11.6083 26.764 11.7654 26.764C11.9224 26.764 12.0777 26.7307 12.2209 26.6663L18.9765 23.5552L18.9987 31.9996ZM12.8876 17.2996V8.88854L19.6431 11.9996C19.7894 12.0673 19.9486 12.1024 20.1098 12.1024C20.271 12.1024 20.4302 12.0673 20.5765 11.9996L27.332 8.88854V17.3108L20.1098 20.6441L12.8876 17.2996ZM35.6765 32.0108L28.4543 35.3441L21.2209 32.0108V23.5774L27.9876 26.6663C28.1293 26.7291 28.2826 26.7615 28.4376 26.7615C28.5926 26.7615 28.7459 26.7291 28.8876 26.6663L35.6431 23.5552L35.6765 32.0108Z"
                fill="currentColor"
              />
            </g>
            <defs>
              <clipPath id="clip0_8127_11313">
                <rect width="40" height="40" fill="currentColor" />
              </clipPath>
            </defs>
          </svg>
        ),
      },
      {
        label: "Role",
        path: MainRoutes?.ROLE,

        icon: (
          <svg
            width="16"
            height="16"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_8145_11333)">
              <path
                d="M24.1329 4.0126C23.9393 3.17739 23.457 2.43739 22.771 1.92318C22.0849 1.40897 21.2393 1.15359 20.3834 1.20212C19.5274 1.25066 18.7161 1.59997 18.0926 2.18843C17.4691 2.77689 17.0735 3.56667 16.9756 4.4184C16.8777 5.27014 17.0838 6.12908 17.5575 6.84366C18.0312 7.55824 18.7421 8.08254 19.5647 8.32402C20.3874 8.5655 21.2688 8.50866 22.0536 8.16351C22.8384 7.81837 23.4761 7.20711 23.8541 6.4376C26.1553 6.96162 28.2945 8.03755 30.0872 9.5726C31.8798 11.1076 33.2722 13.0557 34.1441 15.2489L36.3629 14.3764C35.3358 11.7751 33.6819 9.4679 31.5483 7.65985C29.4147 5.85181 26.8674 4.59893 24.1329 4.0126ZM20.6054 6.0601C20.443 6.06532 20.2811 6.03783 20.1296 5.97928C19.978 5.92072 19.8397 5.8323 19.723 5.71925C19.6062 5.6062 19.5134 5.47084 19.45 5.32121C19.3866 5.17158 19.3539 5.01073 19.3539 4.84823C19.3539 4.68572 19.3866 4.52488 19.45 4.37525C19.5134 4.22562 19.6062 4.09025 19.723 3.97721C19.8397 3.86416 19.978 3.77573 20.1296 3.71717C20.2811 3.65862 20.443 3.63113 20.6054 3.63635C20.9269 3.63635 21.2354 3.7641 21.4627 3.99148C21.6901 4.21887 21.8179 4.52728 21.8179 4.84885C21.8179 5.17043 21.6901 5.47883 21.4627 5.70622C21.2354 5.93361 20.9269 6.0601 20.6054 6.0601ZM15.2716 7.0676L14.3754 4.8501C11.7741 5.87717 9.46692 7.53103 7.65888 9.66466C5.85083 11.7983 4.59796 14.3456 4.01163 17.0801C3.17642 17.2737 2.43641 17.756 1.9222 18.442C1.40799 19.128 1.15262 19.9736 1.20115 20.8296C1.24968 21.6856 1.59899 22.4969 2.18745 23.1204C2.77591 23.7439 3.56569 24.1395 4.41743 24.2374C5.26916 24.3353 6.1281 24.1292 6.84269 23.6555C7.55727 23.1818 8.08156 22.4709 8.32304 21.6483C8.56453 20.8256 8.50768 19.9441 8.16254 19.1593C7.81739 18.3745 7.20613 17.7369 6.43663 17.3589C6.9628 15.0549 8.04223 12.9139 9.5816 11.1208C11.121 9.32767 13.0739 7.93652 15.2716 7.0676ZM4.84663 21.8201C4.6874 21.8201 4.52973 21.7887 4.38262 21.7278C4.23551 21.6669 4.10185 21.5776 3.98926 21.465C3.87667 21.3524 3.78735 21.2187 3.72642 21.0716C3.66549 20.9245 3.63413 20.7668 3.63413 20.6076C3.63413 20.4484 3.66549 20.2907 3.72642 20.1436C3.78735 19.9965 3.87667 19.8628 3.98926 19.7502C4.10185 19.6376 4.23551 19.5483 4.38262 19.4874C4.52973 19.4265 4.6874 19.3951 4.84663 19.3951C5.1682 19.3951 5.4766 19.5228 5.70399 19.7502C5.93138 19.9776 6.05912 20.286 6.05912 20.6076C6.05912 20.9292 5.93138 21.2376 5.70399 21.465C5.4766 21.6924 5.1682 21.8201 4.84663 21.8201ZM20.6054 32.7289C19.9292 32.7311 19.2669 32.9217 18.6931 33.2794C18.1192 33.6371 17.6564 34.1477 17.3566 34.7539C15.0551 34.2299 12.9156 33.1539 11.1227 31.6186C9.32975 30.0833 7.93728 28.1348 7.06537 25.9414L4.84787 26.8376C5.87829 29.4432 7.53768 31.7533 9.67801 33.5617C11.8183 35.37 14.373 36.6204 17.1141 37.2014C17.2716 37.8687 17.6144 38.4779 18.1032 38.9588C18.5919 39.4397 19.2066 39.7727 19.8764 39.9193C20.5462 40.066 21.2438 40.0204 21.8888 39.7877C22.5338 39.555 23.0998 39.1448 23.5217 38.6043C23.9437 38.0638 24.2042 37.4151 24.2734 36.7329C24.3425 36.0507 24.2175 35.3629 23.9126 34.7488C23.6078 34.1346 23.1355 33.6191 22.5504 33.2617C21.9652 32.9043 21.291 32.7196 20.6054 32.7289ZM20.6054 37.5776C20.2838 37.5776 19.9754 37.4499 19.748 37.2225C19.5206 36.9951 19.3929 36.6867 19.3929 36.3651C19.3929 36.0435 19.5206 35.7351 19.748 35.5077C19.9754 35.2803 20.2838 35.1526 20.6054 35.1526C20.9269 35.1526 21.2354 35.2803 21.4627 35.5077C21.6901 35.7351 21.8179 36.0435 21.8179 36.3651C21.8179 36.6867 21.6901 36.9951 21.4627 37.2225C21.2354 37.4499 20.9269 37.5776 20.6054 37.5776ZM39.9991 20.6064C40.0013 19.9573 39.8299 19.3195 39.5025 18.7591C39.1751 18.1987 38.7038 17.7361 38.1373 17.4193C37.5709 17.1025 36.93 16.943 36.2812 16.9573C35.6323 16.9717 34.9991 17.1594 34.4472 17.501C33.8954 17.8425 33.445 18.3256 33.1427 18.8999C32.8404 19.4742 32.6973 20.119 32.7283 20.7673C32.7592 21.4156 32.963 22.0438 33.3186 22.5867C33.6741 23.1297 34.1685 23.5676 34.7504 23.8551C34.2262 26.1564 33.1501 28.2957 31.6148 30.0884C30.0796 31.881 28.1312 33.2733 25.9379 34.1451L26.8354 36.3639C29.441 35.3334 31.7511 33.674 33.5594 31.5337C35.3678 29.3934 36.6182 26.8387 37.1991 24.0976C37.9882 23.911 38.6923 23.4661 39.1996 22.8335C39.7069 22.201 39.9883 21.4171 39.9991 20.6064ZM36.3616 21.8189C36.04 21.8189 35.7316 21.6911 35.5043 21.4637C35.2769 21.2363 35.1491 20.9279 35.1491 20.6064C35.1491 20.2848 35.2769 19.9764 35.5043 19.749C35.7316 19.5216 36.04 19.3939 36.3616 19.3939C36.6832 19.3939 36.9916 19.5216 37.219 19.749C37.4464 19.9764 37.5741 20.2848 37.5741 20.6064C37.5741 20.9279 37.4464 21.2363 37.219 21.4637C36.9916 21.6911 36.6832 21.8189 36.3616 21.8189Z"
                fill="currentColor"
              />
              <path
                d="M23.9894 20.4371C24.679 19.7637 25.1523 18.9 25.3488 17.9563C25.5453 17.0126 25.4561 16.0318 25.0925 15.1391C24.7289 14.2463 24.1076 13.4822 23.3077 12.9443C22.5078 12.4064 21.5658 12.1191 20.6019 12.1191C19.638 12.1191 18.6959 12.4064 17.8961 12.9443C17.0962 13.4822 16.4748 14.2463 16.1112 15.1391C15.7477 16.0318 15.6584 17.0126 15.8549 17.9563C16.0514 18.9 16.5247 19.7637 17.2144 20.4371C16.3937 20.9918 15.7214 21.7392 15.2563 22.6139C14.7913 23.4886 14.5477 24.4639 14.5469 25.4546V27.8783H26.6681V25.4533C26.666 24.4617 26.4207 23.4857 25.9537 22.6109C25.4867 21.7362 24.8122 20.9905 23.9894 20.4371ZM18.1831 16.9683C18.1831 16.6499 18.2458 16.3345 18.3677 16.0403C18.4896 15.7461 18.6682 15.4788 18.8934 15.2536C19.1186 15.0284 19.3859 14.8498 19.6801 14.7279C19.9743 14.606 20.2897 14.5433 20.6081 14.5433C20.9266 14.5433 21.2419 14.606 21.5361 14.7279C21.8303 14.8498 22.0977 15.0284 22.3229 15.2536C22.548 15.4788 22.7267 15.7461 22.8485 16.0403C22.9704 16.3345 23.0331 16.6499 23.0331 16.9683C23.0331 17.6115 22.7776 18.2283 22.3229 18.6831C21.8681 19.1378 21.2513 19.3933 20.6081 19.3933C19.965 19.3933 19.3482 19.1378 18.8934 18.6831C18.4386 18.2283 18.1831 17.6115 18.1831 16.9683ZM16.9706 25.4533C16.9617 24.97 17.0491 24.4898 17.2279 24.0407C17.4066 23.5916 17.6731 23.1827 18.0117 22.8377C18.3503 22.4928 18.7542 22.2188 19.1999 22.0318C19.6456 21.8447 20.1241 21.7484 20.6075 21.7484C21.0909 21.7484 21.5694 21.8447 22.0151 22.0318C22.4608 22.2188 22.8647 22.4928 23.2033 22.8377C23.5419 23.1827 23.8084 23.5916 23.9871 24.0407C24.1659 24.4898 24.2533 24.97 24.2444 25.4533H16.9706Z"
                fill="currentColor"
              />
            </g>
            <defs>
              <clipPath id="clip0_8145_11333">
                <rect width="40" height="40" fill="currentColor" />
              </clipPath>
            </defs>
          </svg>
        ),
      },
      {
        label: "Token",
        path: MainRoutes?.TOKEN,

        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            fill="currentColor"
            className="bi bi-123"
            viewBox="0 0 16 16"
          >
            <path d="M2.873 11.297V4.142H1.699L0 5.379v1.137l1.64-1.18h.06v5.961zm3.213-5.09v-.063c0-.618.44-1.169 1.196-1.169.676 0 1.174.44 1.174 1.106 0 .624-.42 1.101-.807 1.526L4.99 10.553v.744h4.78v-.99H6.643v-.069L8.41 8.252c.65-.724 1.237-1.332 1.237-2.27C9.646 4.849 8.723 4 7.308 4c-1.573 0-2.36 1.064-2.36 2.15v.057zm6.559 1.883h.786c.823 0 1.374.481 1.379 1.179.01.707-.55 1.216-1.421 1.21-.77-.005-1.326-.419-1.379-.953h-1.095c.042 1.053.938 1.918 2.464 1.918 1.478 0 2.642-.839 2.62-2.144-.02-1.143-.922-1.651-1.551-1.714v-.063c.535-.09 1.347-.66 1.326-1.678-.026-1.053-.933-1.855-2.359-1.845-1.5.005-2.317.88-2.348 1.898h1.116c.032-.498.498-.944 1.206-.944.703 0 1.206.435 1.206 1.07.005.64-.504 1.106-1.2 1.106h-.75z" />
          </svg>
        ),
      },
    ],
  },

  {
    label: MODULE_LABELS?.HELP_MANAGEMENT,
    icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.66797 21.6654C7.20964 25.8854 9.80297 29.6337 13.3346 31.6654M33.3346 18.3332C32.927 15.4002 31.5664 12.6826 29.4624 10.599C27.3583 8.51539 24.6276 7.18137 21.6908 6.80242C18.7539 6.42348 15.774 7.02064 13.21 8.50191C10.6459 9.98318 8.64005 12.2664 7.5013 14.9998M6.66797 8.33203V14.9987H13.3346M20.0013 24.9987H23.3346C23.7767 24.9987 24.2006 25.1743 24.5131 25.4869C24.8257 25.7994 25.0013 26.2233 25.0013 26.6654V28.332C25.0013 28.7741 24.8257 29.198 24.5131 29.5105C24.2006 29.8231 23.7767 29.9987 23.3346 29.9987H21.668C21.2259 29.9987 20.802 30.1743 20.4895 30.4869C20.1769 30.7994 20.0013 31.2233 20.0013 31.6654V33.332C20.0013 33.7741 20.1769 34.198 20.4895 34.5105C20.802 34.8231 21.2259 34.9987 21.668 34.9987H25.0013M30.0013 24.9987V28.332C30.0013 28.7741 30.1769 29.198 30.4895 29.5105C30.802 29.8231 31.2259 29.9987 31.668 29.9987H33.3346M35.0013 24.9987V34.9987"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    children: [
      {
        label: MODULE_LABELS?.ADD_FAQ,
        path: MainRoutes?.ADDFAQ,
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-patch-plus"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M8 5.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V10a.5.5 0 0 1-1 0V8.5H6a.5.5 0 0 1 0-1h1.5V6a.5.5 0 0 1 .5-.5"
            />
            <path d="m10.273 2.513-.921-.944.715-.698.622.637.89-.011a2.89 2.89 0 0 1 2.924 2.924l-.01.89.636.622a2.89 2.89 0 0 1 0 4.134l-.637.622.011.89a2.89 2.89 0 0 1-2.924 2.924l-.89-.01-.622.636a2.89 2.89 0 0 1-4.134 0l-.622-.637-.89.011a2.89 2.89 0 0 1-2.924-2.924l.01-.89-.636-.622a2.89 2.89 0 0 1 0-4.134l.637-.622-.011-.89a2.89 2.89 0 0 1 2.924-2.924l.89.01.622-.636a2.89 2.89 0 0 1 4.134 0l-.715.698a1.89 1.89 0 0 0-2.704 0l-.92.944-1.32-.016a1.89 1.89 0 0 0-1.911 1.912l.016 1.318-.944.921a1.89 1.89 0 0 0 0 2.704l.944.92-.016 1.32a1.89 1.89 0 0 0 1.912 1.911l1.318-.016.921.944a1.89 1.89 0 0 0 2.704 0l.92-.944 1.32.016a1.89 1.89 0 0 0 1.911-1.912l-.016-1.318.944-.921a1.89 1.89 0 0 0 0-2.704l-.944-.92.016-1.32a1.89 1.89 0 0 0-1.912-1.911z" />
          </svg>
        ),
      },
      {
        label: MODULE_LABELS?.HELP_CENTER,
        path: MainRoutes?.HELP_CENTER,
        icon: (
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.66797 21.6654C7.20964 25.8854 9.80297 29.6337 13.3346 31.6654M33.3346 18.3332C32.927 15.4002 31.5664 12.6826 29.4624 10.599C27.3583 8.51539 24.6276 7.18137 21.6908 6.80242C18.7539 6.42348 15.774 7.02064 13.21 8.50191C10.6459 9.98318 8.64005 12.2664 7.5013 14.9998M6.66797 8.33203V14.9987H13.3346M20.0013 24.9987H23.3346C23.7767 24.9987 24.2006 25.1743 24.5131 25.4869C24.8257 25.7994 25.0013 26.2233 25.0013 26.6654V28.332C25.0013 28.7741 24.8257 29.198 24.5131 29.5105C24.2006 29.8231 23.7767 29.9987 23.3346 29.9987H21.668C21.2259 29.9987 20.802 30.1743 20.4895 30.4869C20.1769 30.7994 20.0013 31.2233 20.0013 31.6654V33.332C20.0013 33.7741 20.1769 34.198 20.4895 34.5105C20.802 34.8231 21.2259 34.9987 21.668 34.9987H25.0013M30.0013 24.9987V28.332C30.0013 28.7741 30.1769 29.198 30.4895 29.5105C30.802 29.8231 31.2259 29.9987 31.668 29.9987H33.3346M35.0013 24.9987V34.9987"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        ),
      },
    ],
  },
  {
    label: MODULE_LABELS?.CONTACT_BOOK,
    icon: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_8966_18643)">
          <path
            d="M32.7273 17.8571H40V20.8095H32.7273V17.8571ZM29.8182 25.2381H40V28.1905H29.8182V25.2381ZM34.1818 32.619H40V35.5714H34.1818V32.619ZM8 40C8 36.8679 9.22597 33.8641 11.4082 31.6494C13.5905 29.4347 16.5502 28.1905 19.6364 28.1905C22.7225 28.1905 25.6823 29.4347 27.8645 31.6494C30.0468 33.8641 31.2727 36.8679 31.2727 40H28.3636C28.3636 37.6509 27.4442 35.3981 25.8075 33.7371C24.1708 32.076 21.951 31.1429 19.6364 31.1429C17.3217 31.1429 15.1019 32.076 13.4653 33.7371C11.8286 35.3981 10.9091 37.6509 10.9091 40H8ZM19.6364 26.7143C14.8145 26.7143 10.9091 22.7507 10.9091 17.8571C10.9091 12.9636 14.8145 9 19.6364 9C24.4582 9 28.3636 12.9636 28.3636 17.8571C28.3636 22.7507 24.4582 26.7143 19.6364 26.7143ZM19.6364 23.7619C22.8509 23.7619 25.4545 21.1195 25.4545 17.8571C25.4545 14.5948 22.8509 11.9524 19.6364 11.9524C16.4218 11.9524 13.8182 14.5948 13.8182 17.8571C13.8182 21.1195 16.4218 23.7619 19.6364 23.7619Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_8966_18643">
            <rect width="40" height="40" fill="none" />
          </clipPath>
        </defs>
      </svg>
    ),
    children: [
      {
        label: MODULE_LABELS?.DIRECTORY,
        path: MainRoutes?.CONTACTBOOK,
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-journal-text"
            viewBox="0 0 16 16"
          >
            <path d="M5 10.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5" />
            <path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2" />
            <path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z" />
          </svg>
        ),
      },
    ],
  },
];
